<template>
  <div id="timer">
    <span v-if="display">{{time | asTime}}</span>
  </div>
</template>

<script>
import store from '@/store'

// TODO: take object timer as prop instead
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Clock',
  data () {
    return {
      store
    }
  },
  computed: {
    time () {
      return this.store.timer.time
    },
    display () {
      return this.store.timer.display
    }
  }
}
</script>
